import DateRange from '../selectComponents/DateRange';
import DateFilter from '../selectComponents/DateFilter';
import HourFilter from '../selectComponents/HourFilter';
import MultiVariableSelect from '../selectComponents/MultiVariableSelect';
import OutputChoice from '../selectComponents/OutputChoice';

export default function ListhrlyOptions(props) {
  const { userParams, setUserParams, selectOptions, handleChange, setDisableGoButton } = props;

  return (
    <>
      <DateRange 
        userParams={userParams}
        setUserParams={setUserParams}
      />
      <DateFilter
        userParams={userParams}
        setUserParams={setUserParams}
        selectOptions={selectOptions}
        handleChange={handleChange}
      />
      <HourFilter 
        userParams={userParams}
        selectOptions={selectOptions}
        handleChange={handleChange}
      />
      <br />
      <MultiVariableSelect 
        userParams={userParams}
        setUserParams={setUserParams}
      />
      <br />
      <OutputChoice
        userParams={userParams}
        setUserParams={setUserParams}
        choices={['html', 'csv']}
      />
    </>
  )
}
